import React, { FC, useEffect } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Close } from 'common/svg';
import { IUpdateGoodPayload } from 'entities/Goods/Goods.models';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  code?: string;
  onCancel: () => void;
  onSubmit: (payload: Omit<IUpdateGoodPayload, 'id'>) => void;
}

export const ChangeBuyerCodeModal: FC<IComponentProps> = ({ open, loading, code, onCancel, onSubmit }) => {
  const [form] = useForm();

  useEffect(() => {
    if (open) {
      form.setFieldValue('buyerCode', code);
    }
  }, [open, code]);

  const handleCancel = (): void => {
    if (loading) {
      return;
    }

    form.resetFields();
    onCancel();
  };

  const handleSubmit = ({ buyerCode }: Omit<IUpdateGoodPayload, 'id'>): void => {
    onSubmit({
      buyerCode,
      onSuccess: handleCancel,
    });
  };

  return (
    <Modal
      rootClassName="redesign modal"
      styles={{ mask: { background: 'transparent' } }}
      closeIcon={<Close className="icon-close-grey" />}
      width={400}
      centered
      destroyOnClose
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleCancel} loading={loading}>
          Отмена
        </Button>,
        <Button key="submit" className="button-sm primary" loading={loading} onClick={form.submit}>
          Сохранить
        </Button>,
      ]}
    >
      <div className="mb-3 ff-medium fs-m">Артикул клиента</div>
      <div className="mb-6 ff-regular fs-xs color-dark-grey">
        Артикул клиента позволит искать товары в каталоге и системе учета, используя ваши артикулы
      </div>
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item className="mb-6" name="buyerCode">
          <Input placeholder="Введите артикул" allowClear={{ clearIcon: <Close className="icon-close-input" /> }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
